import { useState, useEffect } from "react";
import LoadingApp from "../components-library/loading/LoadingApp";
import useTheme from "../hooks/useTheme";
import useInitialData from "../hooks/useInitialData";
import { AnimatePresence } from "framer-motion";
import { SCREENS } from "../services/exports/Constants";
import useCompanySlug from "../hooks/useCompanySlug";

interface Props {
  children: JSX.Element;
}

const LoadingProvider = (props: Props): JSX.Element => {
  const { children } = props;

  const theme = useTheme();

  const { data } = useInitialData();

  const [loading, setLoading] = useState(true);

  const { slug } = useCompanySlug();

  const isHomePage =
    window.location.pathname === `${SCREENS.HOME_SCREEN}${slug ?? ""}`;

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return (
    <>
      {children}
      <AnimatePresence>
        {loading && isHomePage && (
          <LoadingApp
            color={theme.color.companyBrand.primary}
            logo={data?.franchise?.logo_url}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default LoadingProvider;
